import EnumType from "./EnumType.js";

// TODO: Replace all occurences of DeviceEnum with this enum instead
const values =  {
  USD : 0,
  CAD : 1,
  EUR : 2,
  MXN : 3
};

export default EnumType.generate(values, "Currency.");